/**
 * Created by mac85103 on 9/22/16.
 */
import { Inject, Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";
import { WindowToken } from "@app/util/window.token";

type gatewayGetUserData = {
    authorities: { authority: string }[];
    /** ex: "hoa" */
    clientid: string;
    /** ex: "awd17@gmail.com" */
    email: string;
    /** ex: "Cole" */
    firstname: string;
    /** Entitlement. ex: "26275" */
    hoahomeowner: string;
    /** ex: "Lawrence" */
    lastname: string;
    /** ex: "awd17" */
    name: string;
    phone: string;
    /** ex: "Vantaca" */
    ssoorigin: string;

    uid: string;
};

@Injectable({ providedIn: "root" })
export class OauthService extends HOAApiBase {
    freshLogin: boolean;
    defaultHeaders: any = {};

    constructor(@Inject(WindowToken) public window) {
        super('OauthService');
    }

    /** Make call to get current user */
    getUser(): Observable<gatewayGetUserData> {
        return this.http.get<gatewayGetUserData>(this.createUrl("hoa-gateway", "/user"));
    }

    authenticate(): Observable<any> {
        return new Observable<any>((subscriber) => {
            const authenticateURL = this.getAuthenticateURL();

            try {
                this.window.location.replace(authenticateURL);
            } catch (e) {
                this.window.location.href = authenticateURL;
            }
            subscriber.next(undefined);

        });
    }

    register(): Observable<any> {
        return new Observable<any>((subscriber => {
            const registerURL = this.appDataService.appConfig.get_APP_ENV().OAUTH_REGISTER_URL
            try {
                this.window.location.replace(registerURL);
            } catch (e) {
                this.window.location.href = registerURL;
            }

            subscriber.next(undefined);

        }));
    }

    getFreshLogin(): boolean {
        return this.freshLogin;
    }

    setFreshLogin(freshLogin: boolean) {
        this.freshLogin = freshLogin;
    }

    getAuthenticateURL(): string {
        return this.appDataService.appConfig.get_APP_ENV().OAUTH_AUTHENTICATE_URL;
    }
}

